import './spinner.css';

const Spinner = () => {
  return <>
    <div id="loading-spinner" className="spinner spinner-primary spinner-lg mr-15"></div>
  </>
}

export default Spinner; 
